import { PickupRequestDashboardInitialState } from "../../../types/operations/pickupRequestDashboardInterface";
import { PickupRequestDashboardActionTypes, PickupRequestDashboardActions } from "../../actionTypes/operations/pickupRequestDashboradTypes";

const initialState: PickupRequestDashboardInitialState = {
  dashboardPickupRequestList: [],
  dashboardPickupRequestPageCount: 0,
  pickupStatus: "ALL",
};

export default function dashboardPickupRequestReducer(state = initialState, action: PickupRequestDashboardActionTypes): PickupRequestDashboardInitialState {
  switch (action.type) {
    case PickupRequestDashboardActions.SET_PICKUP_REQUEST_DASHBOARD_LIST:
      return {
        ...state,
        dashboardPickupRequestList: action.payload,
      };

    case PickupRequestDashboardActions.SET_PICKUP_REQUEST_DASHBOARD_PAGE_COUNT:
      return {
        ...state,
        dashboardPickupRequestPageCount: action.payload,
      };

    case PickupRequestDashboardActions.SET_PICKUP_STATUS:
      return {
        ...state,
        pickupStatus: action.payload,
      };

    default:
      return state;
  }
}
